export default {
  apiRoot: window.config.apiRoot,
  testApiRoot: window.config.testApiRoot,
  authEndpoint: window.config.authEndpoint,
  clientId: window.config.clientId,
  appInsights: window.config.appInsights,
  buildNumber: process.env.REACT_APP_BUILD_NUMBER,
  buildNumberFull: process.env.REACT_APP_BUILD_NUMBER_FULL,
  test: window.config.test,
}
